<template>
  <div v-if="ready">
    <div
      v-for="(item, index) in data"
      :key="index"
      class="form-row"
      @click="clickAtSingleList(index)">
      <div
        :class="{'col-md-6': !disabled, 'col-md-5': disabled}"
        class="mb-2"
        style="height: 38px;">
        <div class="d-flex">
          <img
            v-if="showProductImage"
            :src="productImage(item.sku_id)"
            width="35"
            height="35"
            style="margin-right: 10px;border-radius: .25rem;"
          >
          <div style="flex: 1;">
            <template>
              <selectize
                v-if="!disabled && changeSkuAble && !item.disabledSku"
                v-model="item.sku_id"
                :updateoption="item.selectize.updateOption"
                :options="optionSkus"
                :default="item.sku_id"
                :multiple="false"
                :create="createAble"
                :loading="item.selectize.loading"
                :validation="item.selectize.trickValidation"
                :placeholder="createAble ? $t('placeholder.selectorcreate') : $t('placeholder.selectitem')"
                @pick="onPickedSku"/>
              <input
                v-else
                :disabled="disabled || !changeSkuAble || item.disabledSku"
                :value="getSku(item.sku_id) ? getSku(item.sku_id).product_name : null"
                type="text"
                class="form-control">
            </template>
          </div>
        </div>
      </div>
      <div class="col-md-2 mb-2">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">{{ $t('message.quantity') }}</span>
          </div>
          <input
            :disabled="item.sku_id.length == 0 || disabled || item.disabledQty"
            v-model="item.quantity"
            type="text"
            class="form-control text-right number-only text-select-all"
            placeholder=""
            @keypress="numberOnly"
            @keyup="item.quantity = setToValidNumber(item.quantity)"
            @blur="item.quantity = setToCustomDigitsNumber(item.quantity)"
            @change="handleQtyChange($event, item, index)">
        </div>
      </div>
      <div class="col-md-2 mb-2">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">{{ $t('message.cost') }}</span>
          </div>
          <input
            :disabled="item.sku_id.length == 0 || disabled || item.disabledCost"
            v-model="item.cost"
            type="text"
            class="form-control text-right number-only text-select-all"
            placeholder=""
            @keypress="numberOnly"
            @keyup="item.cost = setToValidNumber(item.cost)"
            @blur="item.cost = setToCustomDigitsNumber(item.cost)"
            @change="handleCostChange($event, item, index)">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import useBarcodeScanner from '../../use/barcodeScanner'

export default {
  props: {
    data: {
      type: Array,
    },
    validation: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    createAble: {
      type: Boolean,
      default: true,
    },
    addItemAble: {
      type: Boolean,
      default: true,
    },
    deleteItemAble: {
      type: Boolean,
      default: true,
    },
    changeSkuAble: {
      type: Boolean,
      default: true,
    },
    defaultItems: {
      type: Boolean,
      default: true,
    },
    showProductImage: {
      type: Boolean,
      default: true,
    },
    selectedWhId: String,
  },

  setup () {
    const {
      barcode,
    } = useBarcodeScanner({ delay: 100 })

    return {
      barcode,
    }
  },

  data () {
    return {
      ready: false,

      productsAvailable: [],

      optionSkus: [],
      updateOptionSkus: null,
      loadingSkus: false,
      trickValidationSkus: 0,

      focusAtIndex: 0,
      isFocusOnInput: false,

      isDisabledScanBarcode: false,
    }
  },
  computed: {
    ...mapGetters({
      products: 'getProducts',
      getProductInfoBySkuId: 'getProductInfoBySkuId',
      defaultImages: 'getDefaultImages',
      isAssignedInWarehouse: 'isAssignedInWarehouse',
      isUseLot: 'isUseLot',
      warehouses: 'getWarehouses',
    }),
  },
  watch: {
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
    },
    validation () {
      this.validateform()
    },
    data () {
      this.isFocusOnInput = false
    },
    selectedWhId () {
      this.setProductsAvailable()
    },
  },
  async created () {
    // set dataset
    this.setProductsAvailable()
    // set ready
    this.ready = true
    // default
    if (!this.disabled && this.data.length == 0 && this.defaultItems) {
      this.add()
    }

    // set to digits number
    for (let i in this.data) {
      this.data[i].quantity = this.setToCustomDigitsNumber(this.data[i].quantity)
      this.data[i].cost = this.setToCustomDigitsNumber(this.data[i].cost)
    }

    window.addEventListener('barcode', this.onBarcode)
  },
  destroyed: function () {
    window.removeEventListener('barcode', this.onBarcode)
  },
  methods: {
    inputClick (index) {
      let isLast = index == this.data.length - 1
      if (isLast) {
        this.add()
      }
    },
    add () {
      var that = this
      that.focusAtIndex = that.data.length
      that.data.push({
        sku_id: '',
        item: '',
        description: '',
        quantity: this.setToCustomDigitsNumber(0),
        cost: this.setToCustomDigitsNumber(0),
        selectize: {
          loading: false,
          updateOption: null,
          trickValidation: 0,
        },
      })
    },
    del (index) {
      this.data.splice(index, 1)

      let that = this
      if (that.data.length == 0) {
        setTimeout(() => {
          that.add()
        }, 100)
      }
    },
    getData () {
      var data = _.cloneDeep(this.data)

      var newData = []

      // remove key, data we don't need
      for (let i in data) {
        let order = data[i]
        if (order.sku_id) {
          newData.push({
            sku_id: order.sku_id,
            item: order.item,
            quantity: parseFloat(order.quantity) || 0,
            cost: parseFloat(order.cost) || 0,
          })
        }
      }

      return newData
    },
    isValid () {
      /*
       *  validation
       */
      let data = this.getData()

      if (data.length == 0) {
        this.data[0].selectize.trickValidation++
      }

      return data.length != 0
    },
    validateform () {
      var data = null
      var isValid = false
      if (this.isValid()) {
        data = this.getData()
        isValid = true
      }
      this.$emit('submit', isValid, data)
    },
    onPickedSku (value) {
      let sku_id = value
      let sku = this.getSku(sku_id)
      if (sku) {
        let data = this.data.find((order, index) => index == this.focusAtIndex)
        this.focusAtIndex++
        if (data) {
          if (data.sku_id.length > 0 && this.isFocusOnInput) {
            data.item = sku.product_name
            data.quantity = this.setToCustomDigitsNumber(1)
            data.cost = this.setToCustomDigitsNumber(0)
            this.emitOnChange(sku_id)
          }
        }
      }
    },
    setOptionSkus () {
      this.optionSkus = []
      for (let i in this.productsAvailable) {
        let item = this.productsAvailable[i]
        this.optionSkus.push({
          text: item.product_name,
          value: item.sku_id,
        })
      }
    },
    getSku (sku_id) {
      for (let i in this.productsAvailable) {
        let item = this.productsAvailable[i]
        if (item.sku_id == sku_id) {
          return item
        }
      }
      return null
    },
    getSkuByBarcode (barcode) {
      for (let i in this.productsAvailable) {
        let item = this.productsAvailable[i]
        if (item.barcode == barcode) {
          return item
        }
      }
      return null
    },
    clickAtSingleList (index) {
      this.focusAtIndex = index
      this.isFocusOnInput = true
    },
    setProductsAvailable () {
      this.productsAvailable = []
      for (let i in this.products) {
        let product = this.products[i]
        for (let j in product.prices) {
          let price = product.prices[j]
          const pass = this.isUseLot(price.sku_id) && this.isAssignedInWarehouse(price.sku_id, this.selectedWhId)
          if (pass) {
            this.productsAvailable.push({
              product_name: this.getProductFullName(product.product_name, price.attributes),
              sku_id: price.sku_id,
              price: price.price || 0,
              cost: price.cost || 0,
              barcode: price.barcode,
              unit: product.unit,
              config: price.config,
            })
          }
        }
      }
      for (let i in this.data) {
        const hasSku = this.data[i].sku_id
        const notExist = !this.productsAvailable.find((item) => item.sku_id === this.data[i].sku_id)
        if (hasSku && notExist) {
          this.productsAvailable.push({
            product_name: this.data[i].item,
            sku_id: this.data[i].sku_id,
            price: this.data[i].price || 0,
            cost: 0,
            unit: null,
          })
        }
      }
      this.setOptionSkus()
    },
    onBarcode (event) {
      if (this.disabled || this.isDisabledScanBarcode) {
        return
      }

      const addAtIndex = this.data.findIndex((order, index) => !order.sku_id)
      const sku = this.getSkuByBarcode(event.detail.code)
      const isSkuExistAtIndex = sku && this.data.findIndex((item) => item.sku_id == sku.sku_id)

      if (sku) {
        if (isSkuExistAtIndex >= 0) {
          const data = this.data[isSkuExistAtIndex]
          data.quantity = (Number(data.quantity) + 1).toFixed(2)
        } else if (addAtIndex === -1) {
          this.data.splice(0, 1)
          this.data.push({
            'sku_id': sku.sku_id,
            'item': sku.product_name,
            'quantity': '1.00',
            'cost': '0.00',
            'selectize': {
              'loading': false,
              'updateOption': null,
              'trickValidation': 0,
            },
          })
          this.emitOnChange(sku.sku_id)
        } else {
          const data = this.data[addAtIndex]
          data.sku_id = sku.sku_id
          data.item = sku.product_name
          data.quantity = '1.00'
          data.cost = '0.00'
          data.selectize = {
            'loading': false,
            'updateOption': null,
            'trickValidation': 0,
          }
          this.emitOnChange(sku.sku_id)
        }
      } else {
        this.notify(this.$vs, {
          text: this.$t('message.notfoundbarcode', { code: event.detail.code }),
          color: 'warning',
          icon: 'warning',
          time: 3000,
        })
      }
    },
    productImage (skuId) {
      if (!skuId) return this.defaultImages.product
      const product = this.getProductInfoBySkuId(skuId)
      return (product && product.images.thumbnail) || this.defaultImages.product
    },
    handleQtyChange (e, item, index) {
      this.emitOnChange(item.sku_id)
    },
    handleCostChange(e, item, index) {
      this.emitOnChange(item.sku_id)
    },
    emitOnChange(skuId) {
      const order = this.data.find((item) => item.sku_id === skuId)
      this.$emit('onChange', {
        skuId: order.sku_id,
        quantity: Number(order.quantity),
        cost: Number(order.cost),
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/custom/OrderLot.vue